(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["review-page-modal"] && !Shopify.designMode) return;
  try {
    
/* Review page modal — standalone script.
   Opens with: [data-rvm-open="<section id>"], [data-rvm-open] (first modal), or any link to #reviews. */
(function () {
  'use strict';
  var lastFocus = null;
  var prevOverflow = '';

  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function find(id) {
    return id ? document.querySelector('[data-rvm="' + id + '"]') : document.querySelector('[data-rvm]');
  }
  function lock(state) {
    var html = document.documentElement;
    if (state) { prevOverflow = html.style.overflow; html.style.overflow = 'hidden'; }
    else { html.style.overflow = prevOverflow; }
  }

  /* Import live review cards from the linked main review section.
     The selector is configured in this section's settings. Cards are cloned so the
     modal can style them without moving or modifying the original review section. */
  function syncSourceReviews(modal) {
    if (!modal) return;
    var selector = modal.getAttribute('data-rvm-source');
    if (!selector) return;
    var list = modal.querySelector('[data-rvm-list]');
    if (!list) return;
    var sources;
    try { sources = all(selector); } catch (err) { return; }
    if (!sources.length) return;

    var imported = [];
    sources.forEach(function (source) {
      /* If the selector targets a list/container, import its direct review-like children.
         If it targets individual cards, import the matched card itself. */
      var children = source.querySelectorAll('[data-review-card], .review-card, .review-item, .jdgm-rev, .spr-review, .okeReviews-reviews-review');
      if (children.length && !source.matches('[data-review-card], .review-card, .review-item, .jdgm-rev, .spr-review, .okeReviews-reviews-review')) {
        Array.prototype.forEach.call(children, function (child) { imported.push(child); });
      } else {
        imported.push(source);
      }
    });
    if (!imported.length) return;
    list.innerHTML = '';
    imported.forEach(function (source, index) {
      var clone = source.cloneNode(true);
      clone.removeAttribute('id');
      clone.removeAttribute('hidden');
      clone.classList.add('rv__item');
      clone.removeAttribute('data-rvm-open');
      clone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      list.appendChild(clone);
    });
    list.setAttribute('data-batch', String(imported.length));
    var footer = modal.querySelector('.rv__foot');
    if (footer) footer.hidden = true;
    var headingCount = modal.querySelector('.rv__allhead span');
    if (headingCount) headingCount.textContent = '(' + imported.length + ')';
  }

  function open(modal) {
    if (!modal || modal.classList.contains('is-open')) return;
    all('.rvm.is-open').forEach(close);
    syncSourceReviews(modal);
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    lock(true);
    var panel = modal.querySelector('.rvm__panel');
    if (panel) panel.scrollTop = 0;
    var x = modal.querySelector('.rv__x');
    if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 60);
  }

  function close(modal) {
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    lock(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* reveal the next batch of reviews */
  function more(btn) {
    var modal = btn.closest('.rvm');
    var list = modal && modal.querySelector('[data-rvm-list]');
    if (!list) return;
    var batch = parseInt(list.getAttribute('data-batch'), 10) || 5;
    all('.rv__item[hidden]', list).slice(0, batch).forEach(function (el) { el.hidden = false; });
    if (!list.querySelector('.rv__item[hidden]')) {
      var href = btn.getAttribute('data-href');
      if (href) {
        var a = document.createElement('a');
        a.className = 'rv__seeall';
        a.href = href;
        a.textContent = btn.getAttribute('data-label-all') || btn.textContent;
        btn.replaceWith(a);
      } else {
        btn.hidden = true;
      }
    }
  }

  /* one delegated listener: works for sections added later in the theme editor */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var opener = t.closest('[data-rvm-open]');
    if (opener) { e.preventDefault(); open(find(opener.getAttribute('data-rvm-open'))); return; }
    var link = t.closest('a[href$="#reviews"]');
    if (link && find()) { e.preventDefault(); open(find()); return; }
    var closer = t.closest('[data-rvm-close]');
    if (closer) { close(closer.closest('.rvm')); return; }
    var btn = t.closest('[data-rvm-more]');
    if (btn) more(btn);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') all('.rvm.is-open').forEach(close);
  });

  /* Put the rating line into a slot elsewhere on the page.
     Add <div data-rvm-slot></div> in a Custom Liquid block (e.g. above the product title)
     and the rating line moves there. Or set "place above this element" in the section settings.
     Without either, it stays where the section is. */
  var lineRegistry = {};
  function placeLines() {
    all('[data-rvm-line]').forEach(function (el) {
      var id = el.getAttribute('data-rvm-line');
      if (!lineRegistry[id] || (lineRegistry[id] !== el && !document.contains(lineRegistry[id]))) lineRegistry[id] = el;
      else if (lineRegistry[id] !== el) { el.parentNode.removeChild(el); }
    });
    Object.keys(lineRegistry).forEach(function (id) {
      var line = lineRegistry[id];
      var slot = document.querySelector('[data-rvm-slot="' + id + '"]') ||
                 document.querySelector('[data-rvm-slot=""]:not(:has([data-rvm-line]))') ||
                 document.querySelector('[data-rvm-slot]:not(:has([data-rvm-line]))');
      if (line.closest && line.closest('[data-rvm-slot]')) return;
      if (slot) { slot.appendChild(line); return; }
      /* no slot: place the line above an element chosen in the section settings (e.g. h1) */
      var sel = line.getAttribute('data-rvm-before');
      if (!sel) return;
      var target = null;
      try { target = document.querySelector(sel); } catch (err) { target = null; }
      if (target && target.parentNode && target.previousElementSibling !== line) target.parentNode.insertBefore(line, target);
    });
  }
  function initLines() { placeLines(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLines); else initLines();
  document.addEventListener('shopify:section:load', function (e) {
    var fresh = e.target && e.target.querySelector && e.target.querySelector('[data-rvm-line]');
    if (fresh) {
      var id = fresh.getAttribute('data-rvm-line');
      var old = lineRegistry[id];
      if (old && old !== fresh && old.parentNode) old.parentNode.removeChild(old);
      lineRegistry[id] = fresh;
    }
    placeLines();
  });

  /* open straight away when the page URL ends in #reviews */
  function fromHash() { if (location.hash === '#reviews') open(find()); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromHash); else fromHash();

  /* theme editor: show the modal while its section is selected */
  document.addEventListener('shopify:section:select', function (e) {
    var m = e.target && e.target.querySelector && e.target.querySelector('.rvm');
    if (m) open(m);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var m = e.target && e.target.querySelector && e.target.querySelector('.rvm');
    if (m) close(m);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var gone = e.target && e.target.querySelector && e.target.querySelector('[data-rvm-line]');
    var gid = e.target && e.target.id ? e.target.id.replace('shopify-section-', '') : '';
    if (gid && lineRegistry[gid] && lineRegistry[gid].parentNode) { lineRegistry[gid].parentNode.removeChild(lineRegistry[gid]); delete lineRegistry[gid]; }
    var m = e.target && e.target.querySelector && e.target.querySelector('.rvm.is-open');
    if (m) lock(false);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var m = e.target && e.target.closest && e.target.closest('.rvm');
    if (!m) return;
    open(m);
    e.target.hidden = false;
    e.target.scrollIntoView({ block: 'center', behavior: 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
